import styled from "styled-components";

export const Circle = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    padding: 10px;
    background: rgb(40 117 206);
    margin-left: 8px;
    width: 40px;
    height: 40px;
    cursor: pointer;

    // case for disabled
    ${({disabled}) => disabled && `
        background: #ccc;
        cursor: not-allowed;
    `}
`;
